import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { METRIC_KEY } from '@/consts/searchKeys';
import { MetricDefinition } from '@/types/metric';

const NO_ADDITIONAL_KEYS: string[] = [];

export const useEnsureMetricKey = (
  initialMetricKey?: string,
  metricData?: MetricDefinition[],
  additionalValidKeys: string[] = NO_ADDITIONAL_KEYS,
) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentMetricKey = searchParams.get(METRIC_KEY);

  useEffect(() => {
    if (!metricData || metricData.length === 0) return;

    const availableKeys = metricData.map(metric => metric.key);
    const validKeys = [...availableKeys, ...additionalValidKeys];
    if (currentMetricKey && validKeys.includes(currentMetricKey)) return;

    const fallbackMetricKey = availableKeys[0];
    const metricKey = initialMetricKey && validKeys.includes(initialMetricKey) ? initialMetricKey : fallbackMetricKey;

    searchParams.set(METRIC_KEY, metricKey);
    setSearchParams(searchParams, { replace: true });
  }, [currentMetricKey, initialMetricKey, metricData, additionalValidKeys]);
};
